module.exports = __webpack_public_path__ + "static/media/hasznSeged_ikon.91e494c9.svg";